import { useTranslation } from 'react-i18next';
import { DragDropContext, Droppable, Draggable, DropResult } from '@hello-pangea/dnd';
import { DraggableCard, IndexCard } from '@/components';
import { ProjectDto } from '@/core';
import { findColumnNameById } from './helpers';
import classes from './TableFormColumns.module.scss';

type TableFormColumnsProps = {
  columns: string[];
  handleDeleteColumn: (column: string) => void;
  isSummaryTable: boolean;
  handleDragColumn: (columns: string[]) => void;
  projectData: ProjectDto;
};

export const TableFormColumns = ({
  columns,
  handleDeleteColumn,
  isSummaryTable,
  handleDragColumn,
  projectData,
}: TableFormColumnsProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const orderedColumns = [...columns];

  const handleDragEnd = (result: DropResult) => {
    const { source, destination } = result;

    if (!result.destination) {
      return;
    }

    const [removed] = orderedColumns.splice(source?.index!, 1);
    orderedColumns.splice(destination?.index!, 0, removed);
    handleDragColumn(orderedColumns);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="tableColumns" direction="vertical">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef} className={classes.columnsList}>
            <div className={classes.indexesList}>
              {orderedColumns.map((column, index) => (
                <IndexCard key={column} index={index + 1} />
              ))}
              {isSummaryTable && (
                <>
                  <IndexCard index={orderedColumns.length + 1} />
                  <IndexCard index={orderedColumns.length + 2} />
                </>
              )}
            </div>
            <div className={classes.columnWrapper}>
              {orderedColumns.map((column, index) => (
                <Draggable key={column} draggableId={column} index={index}>
                  {(provided, snapshot) => (
                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                      <DraggableCard
                        isDeletable
                        isDraggable
                        handleDelete={() => handleDeleteColumn(column)}
                        cardText={findColumnNameById(column, projectData)}
                        isDragging={snapshot.isDragging}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
              {isSummaryTable && (
                <>
                  <DraggableCard cardText={t('addTables.totalHours')} />
                  <DraggableCard cardText={t('addTables.total')} />
                </>
              )}
            </div>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
